import { useEffect, useRef, useState } from "react";
import { Image as ImageIcon } from "@phosphor-icons/react";
import { CtnPhoto } from "./CtnPhoto";

export const CtnListPhoto = ({ id, alt, testId }) => {
  const element = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!id || !element.current) return;
    if (!("IntersectionObserver" in window)) { setVisible(true); return; }
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) { setVisible(true); observer.disconnect(); }
    }, { rootMargin: "240px 0px" });
    observer.observe(element.current);
    return () => observer.disconnect();
  }, [id]);
  return <div ref={element} className="ctn-list-photo" data-testid={`${testId}-frame`}>
    {!id || visible ? <CtnPhoto id={id} alt={alt} testId={testId} variant="lijst" />
      : <div className="ctn-photo-placeholder" data-testid={`${testId}-loading`}><ImageIcon size={28} aria-hidden="true" /></div>}
  </div>;
};